module.exports = __webpack_public_path__ + "img/SS.c05dcec9.png";